@if(messageLoading()) {
<div class="flex flex-col gap-4">
  <p-skeleton width="5rem" styleClass="mb-2" />
  <p-skeleton width="5rem" styleClass="mb-2" />
  <p-skeleton width="5rem" styleClass="mb-2" />
</div>
}

<div class="chat flex flex-col h-full w-full relative">
  <ul #scrollChat class="chat__message-list flex-1 overflow-y-auto">
    @for (messageData of messagesWithUsers(); track messageData) {
    <li class="flex w-full gap-1 my-2">
      @if(!messageData.isOutgoing && messageData.user?.full_name) {
      <div class="flex items-start justify-end">
        <offconon-monogram
          avatarClass="h-12 w-12 min-h-12 min-w-12"
          textClass="text-md"
          [name]="messageData.user?.full_name || '' " />
      </div>
      }
      <div class="flex w-full items-center">
        @if(messageData?.message?.message) {
        <div class="message-media">
          <!-- Image -->
          @if(isImageUrl(messageData?.message?.message)) {
          <img alt="Sent Image" [src]="messageData?.message?.message" />
          }

          <!-- Video -->
          @if(isVideoUrl(messageData?.message?.message)) {
          <video controls>
            <source [src]="messageData?.message?.message" />
            Your browser does not support the video tag.
          </video>
          }

          <!-- Audio -->
          @if(isAudioUrl(messageData?.message?.message)) {
          <audio controls>
            <source [src]="messageData?.message?.message" />
            Your browser does not support the audio tag.
          </audio>
          }

          <!-- YouTube -->
          <!--<iframe *ngIf="isYouTubeUrl(messageData?.message?.message)" width="100%" height="315"
                  [src]="isYouTubeUrl(messageData?.message?.message)" allowfullscreen></iframe>-->
        </div>
        }
        <!-- Text Message -->
        @if(!isImageUrl(messageData?.message?.message) && !isVideoUrl(messageData?.message?.message)
        && !isAudioUrl(messageData?.message?.message) &&
        !isYouTubeUrl(messageData?.message?.message)) {
        <div
          class="p-3 px-5 message"
          [ngClass]="{
                 'bg-primary message-outgoing ml-auto text-white': messageData.isOutgoing,
                 'box-bg message-incoming': !messageData.isOutgoing
               }">
          {{ messageData?.message?.message }}
        </div>
        }
      </div>
    </li>
    }
  </ul>

  @if(!isScrolledToBottom()) {
  <button
    pButton
    icon="pi pi-arrow-down"
    class="p-button-rounded p-button-text fixed bottom-4 right-4 z-10"
    aria-label="Scroll to bottom"
    (click)="scrollToBottom()"></button>
  }
</div>
